import { LOCALES } from './locales';

const getMessagesForLocale = locale => LOCALES[locale];

export { getMessagesForLocale };
